import { render } from "./OrderCreateShop.vue?vue&type=template&id=bb9e2ce0"
import script from "./OrderCreateShop.vue?vue&type=script&lang=js"
export * from "./OrderCreateShop.vue?vue&type=script&lang=js"

import "./OrderCreateShop.vue?vue&type=style&index=0&id=bb9e2ce0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__